import { render, staticRenderFns } from "./tbmInfo.vue?vue&type=template&id=3f908935"
import script from "./tbmInfo.vue?vue&type=script&lang=js"
export * from "./tbmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f908935')) {
      api.createRecord('3f908935', component.options)
    } else {
      api.reload('3f908935', component.options)
    }
    module.hot.accept("./tbmInfo.vue?vue&type=template&id=3f908935", function () {
      api.rerender('3f908935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmInfo.vue"
export default component.exports